import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraDataTable } from '@mono/ui-components/captains';
import { SpecraBadge } from '@mono/ui-components/ensigns';
import { Testids } from '@mono/ui-selectors';
import { cents } from '../ratesView';
export function ClinsTab({ clins, byClin, onNavigate }) {
    return /*#__PURE__*/ _jsx(SpecraDataTable, {
        "data-testid": Testids.pricingWorkspace.clinsTable,
        rows: clins,
        rowKey: (clin)=>clin.clinNumber,
        getRowLabel: (clin)=>`CLIN ${clin.clinNumber}`,
        onRowClick: (clin)=>onNavigate(`clin/${clin.clinNumber}`),
        columns: [
            {
                id: 'number',
                header: 'CLIN',
                cell: (clin)=>clin.clinNumber
            },
            {
                id: 'title',
                header: 'Title',
                cell: (clin)=>clin.metadata.title ?? '—'
            },
            {
                id: 'type',
                header: 'Type',
                cell: (clin)=>/*#__PURE__*/ _jsx(SpecraBadge, {
                        children: clin.metadata.contractType || 'Generic'
                    })
            },
            {
                id: 'period',
                header: 'Period',
                cell: (clin)=>clin.metadata.periodName || clin.periods.join(', ')
            },
            {
                id: 'total',
                header: 'Total',
                cell: (clin)=>cents(byClin?.[clin.clinNumber])
            },
            {
                id: 'removed',
                header: 'Status',
                cell: (clin)=>clin.metadata.removedByAmendment ? /*#__PURE__*/ _jsx(SpecraBadge, {
                        variant: "warning",
                        children: "Removed by amendment"
                    }) : 'Active'
            }
        ]
    });
}
